__turbopack_context__.v({
  "footerButton": "footer-module-scss-module__SPPmNq__footerButton",
});
